import { render } from "./usergroupdetailview.vue?vue&type=template&id=79e34870"
import script from "./usergroupdetailview.vue?vue&type=script&lang=js"
export * from "./usergroupdetailview.vue?vue&type=script&lang=js"

import "./usergroupdetailview.vue?vue&type=style&index=0&id=79e34870&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__